import React, {useEffect} from 'react'
import {StyledSubtitle} from './style'
import {useTranslation} from 'react-i18next'
import Modal from '@/components/commons/Modal'
import {handleApiError} from '@/utilities/helpers'
import Spinner from '@/components/ui/Spinner'
import {useReject} from '@/features/videos/queries/useReject'

interface RejectModalProps {
    videoId: string
    workspaceId: string
    jobId: string
    userId: string
    onClose: () => void
}

const RejectModal: React.FC<RejectModalProps> = ({videoId, workspaceId, jobId, userId, onClose}: RejectModalProps) => {
    const {t} = useTranslation()
    const {mutate, isPending, isError, error} = useReject({
        projectId: `${videoId}`,
        jobId: `${jobId}`,
        userId: `${userId}`,
        workspaceId: `${workspaceId}`,
        onSuccess: onClose
    })

    useEffect(() => {
        if (isError) handleApiError({error})
    }, [isError])

    const onClickClose = () => {
        onClose()
    }

    const onSubmit = () => {
        if (userId) mutate()
    }

    if (isPending) return <Spinner size={48} overlay />

    return (
        <Modal
            overlay
            title={'reject_modal:title'}
            onClose={onClickClose}
            cancelButtonCallback={onClickClose}
            submitButtonCallback={onSubmit}
            submitButtonText={'reject_modal:submit_button'}
        >
            <StyledSubtitle>{t('reject_modal:subtitle')}</StyledSubtitle>
        </Modal>
    )
}

export default RejectModal

RejectModal.displayName = 'RejectModal'
